import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

import Page from '../components/Page';
import notFound from '../images/404.jpg';

export default class PageNotFound extends Component{

    render() {
        return(
            <Page>
                <div className="clearfix card not-found">
                    <img src={ notFound } alt="Page Not Found" className="img-responsive" />
                    <h3>We could not find this page, sorry</h3>

                    <NavLink className="btn btn-primary btn-lg" to="/">
                        &larr; Go back to home
                    </NavLink>
                </div>
            </Page>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/PageNotFound.js